<template>
  <div class="main">
    <div class="question">
      <a-row style="margin-top:20px;">
        <router-link :to="{name: 'QuestionSolve'}">
          <a-col :span="6" class="queLeft">
            <p class="open_issus">待解决问题</p>
            <div class="num">
              <span>{{questionNum}}个问题待解决</span>
              <img class="more" src="../../assets/image/a_right.png" alt="">
            </div>
          </a-col>
        </router-link>
        <router-link :to="{name: 'ExpertReply'}">
          <a-col :span="6" class="queCenter">
            <p class="open_issus">专家回复</p>
            <div class="num">
              <span> {{expertanswer}}个最新回复</span>
              <img class="more" src="../../assets/image/a_right.png" alt="">
            </div>
          </a-col>
        </router-link>
        <router-link :to="{name: 'ClassifyQuestion'}">
          <a-col :span="6" class="queRight">
            <div class="classification">
              <span class="text">问题归类</span>
              <img class="more" src="../../assets/image/a_right.png" alt="">
            </div>
          </a-col>
        </router-link>
      </a-row>
    </div>
    <div class="taskManger">
      <div class="taskLeft">
        <div class="taskLeftText">
        </div>
      </div>
      <div class="taskRight">
        <a-row type="flex" justify="space-between">
          <a-col class="col" @click="task">
            <img src="../../assets/image/a_task.png" alt="" />
            <div class="text">任务追踪</div>
          </a-col>
          <a-col class="col" @click="routerLink('NewPersonHomeWork')">
            <img src="../../assets/image/a_homeWork.png" alt="" />
            <div class="text">个人任务</div>
          </a-col>
          <a-col class="col" @click="routerLink('NewGroupWork')" v-show="false">
            <img src="../../assets/image/a_groupWork.png" alt="" />
            <div class="text">小组任务</div>
          </a-col>
          <a-col class="col" @click="routerLink('StudentsExercises')">
            <img src="../../assets/image/a_exerices.png" alt="" />
            <div class="text">学生习题</div>
          </a-col>
          <a-col class="col" @click="studentsDraw">
            <img src="../../assets/image/student_draw.png" alt="" />
            <div class="text">学生画像</div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="className">
      <div class="nameLeft">
        <span class="border"></span>
        <span class="borderName">班级管理</span>
      </div>
      <div class="nameRight">
        <a-button class="classBtn" @click="addNewClass">
          <a-icon type="plus-circle" />新建班级
        </a-button>
      </div>
    </div>
    <div class="mesList">
      <ul>
        <li v-for="(item,index) in classData" :key="index">
          <div class="mesLeft">
            <div class="mesTitle" @click="goClassMain(item)">
              <span class="class-name"> {{item.className}} </span>
              <img class="mesImg" src="../../assets/image/a_right.png" alt="" />
              <div v-show="item.isStudentJoin==1" class="tooltips" @click.stop="lookApply(item)">
                   <a-icon type="sound"/>
                   <span class="joinClass">有同学想加入班级</span>
              </div>
            </div>
            <div class="mesCont">
              <img class="mesImg" src="../../assets/image/a_mess.png" alt="" />
              <span class="mesContNotice">{{item.intro || '暂无公告'}}</span>
            </div>
          </div>
          <div class="mesRight">
            <div class="mangerRight" @click="goGroup(item)">
              <img src="../../assets/image/a_manger.png" alt="" />
              <div class="imgText">分组管理</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <a-modal class="classNumber" v-model="release" width="440px" title="" footer="" destroyOnClose>
      <div class="classTop">
        <a-checkbox-group @change="checkClass">
          <div class="classSelect" v-for="(item, index) in classData" :key="index">
            <a-checkbox :value="item.id">{{item.className}}</a-checkbox>
          </div>
        </a-checkbox-group>
        <div class="classBot">
          <a-button class="cancelButton" @click="release = false">取消</a-button>
          <a-button class="classSureButton" :disabled="disabledClass ==false" @click="classSure">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal class="classNumber" v-model="addClassModel" width="440px" title="新建班级群" @ok="addNewClassFun"
             @cancel="cancelNewClass" destroyOnClose>
      <a-row class="classTop">
        <a-col :span="4" class="classGroup">班级群名:</a-col>
        <a-col :span="20"><a-input class="newName" v-model="newClassName" /></a-col>
      </a-row>
    </a-modal>
    <a-modal title="" :visible="applyVisible" footer="" @cancel="handleCancel">
      <ul>
        <li class="applyLi" v-for="(item,index) in applyList" :key="index">
          <div class="applyName">
            <img class="userImg" :src="item.photo&&item.photo!=null?$userINfoBasePath+'/'+item.photo: mrImg"
                 alt=""/>
            <span class="userName">{{ item.userName }}</span>
            <span class="name">请求加入</span>
            <span class="className">{{ item.className }}</span>
          </div>
          <div class="applyFun">
            <a-button v-if="item.isPermit === 0" class="sure" type="primary"
                      @click="sureFun(item)">同意
            </a-button>
            <a-button v-if="item.isPermit === 0" class="refuse" type="danger"
                      @click="refuseFun(item)">拒绝
            </a-button>
            <a-button v-if="item.isPermit === 1" class="sure" type="primary">已同意</a-button>
            <a-button v-if="item.isPermit === 2" class="sure" type="primary">已拒绝</a-button>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import shareState from '../../utils/shareState.js';
export default {
  name: 'AccompanyStudy',
  components: {},
  created() {},
  data() {
    return {
      mrImg: require('../../assets/imgs/student.png'),
      shareData: shareState.state,
      questionNum: '',
      expertanswer: '',
      listData: [],
      release: false,
      disabledClass: false,
      classData: [],
      orderParam: [], // 选择的发布班级
      getToName: '',
      addClassModel: false,
      newClassName: '',
      classId: '',
      applyList: [],
      isStudentJoin: '',
      applyVisible: false,
      applyParam: null, // 学生加入班级同意或者拒绝参数
      timer: null,
    };
  },
  mounted() {
    this.getClassNum();
    this.getBookLessonList();
    this.getexpertList();
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        setTimeout(() => {
          this.getBookLessonList();
          this.getexpertList();
        }, 10);
      }, 30000);
    },
    getBookLessonList() {
      // 待解决问题数量
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getTeacherToBeSolvedCount',
        body: { userId: this.$store.state.userInfo.id },
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.questionNum = res.resultData;
        }
      });
    },
    getexpertList() {
      // 专家最新回复问题数量
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getExpertNewestReplyCount',
        body: { userId: this.$store.state.userInfo.id },
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.expertanswer = res.resultData;
        }
      });
    },
    getClassNum() {
      // 班级列表
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/common/getMyClassInfo',
        body: { userId: this.$store.state.userInfo.id },
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.classData = res.resultData;
        }
      });
    },
    checkClass(val) {
      // 选择班级
      this.orderParam = val;
      // window.localStorage.setItem('classId',this.orderParam)
      if (this.orderParam.length > 0) {
        this.disabledClass = true;
      } else {
        this.disabledClass = false;
      }
    },
    classSure() {
      if (this.orderParam.length < 1) {
        return;
      }
      if (this.orderParam.length > 1) {
        this.$message.warning('请您选择一个班级查看');
        return;
      }
      this.getClassStyleTask();
      this.getTaskSelectInfo();
      if (this.getToName == '任务追踪') {
        shareState.setHomeWorkClassId(this.orderParam[0]);
        this.$router.push({ name: 'TaskHistory', params: { classId: this.orderParam } });
      } else if (this.getToName == '个人作业') {
        shareState.setHomeWorkClassId(this.orderParam[0]);
        this.$router.push({ name: 'PersonHomeWork', params: { classId: this.orderParam } });
      } else if (this.getToName == '小组作业') {
        shareState.setHomeWorkClassId(this.orderParam[0]);
        this.$router.push({ name: 'GroupHomeWork', params: { classId: this.orderParam } });
      }
    },
    getClassStyleTask() {
      const param = {
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$store.state.userInfo.id,
        classId: this.orderParam.toString(),
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/task/getTaskByClassIdAndStyleId',
        body: param,
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            this.release = false;
          }
        });
    },
    getTaskSelectInfo() {
      if (this.orderParam.length < 1) {
        return;
      }
      const param = {
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$store.state.userInfo.id,
        classId: this.orderParam.toString(),
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/task/getTaskFinishStatistics',
        body: param,
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            this.release = false;
          }
        });
    },
    routerLink(name) {
      this.$router.push({ name: name });
    },
    task() {
      this.$router.push({ name: 'TaskHistory' });
    },
    studentsDraw() {
      // 学生画像
      this.$router.push({ name: 'StudentsDraw' });
    },
    goClass() {
      // 跳转到班级
      // this.$router.push({ name: 'Class' })
    },
    goClassMain(item) {
      // 进入班级页面
      localStorage.setItem('classID', item.id); // 缓存当前小组的班级ID
      this.$router.push({ path: `/accompanyStudy/class/chat/${item.groupTag}` });
    },
    goGroup(item) {
      // 进入小组页面
      this.classId = item.id;
      localStorage.setItem('classID', item.id); // 缓存当前小组的班级ID
      this.$store.commit('setGroupLists', []); // 先清空后获取小组列表
      // this.getGroupNum();
      // this.$router.push({ name: 'Class' })
      this.$router.push({ path: '/accompanyStudy/group/chat/undefined' });
    },
    getGroupNum() {
      const _this = this;
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/class/common/getClassInfoById',
          body: { id: _this.classId },
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.groupsMess = res.resultData.groups;
            _this.$store.commit('setGroupLists', res.resultData.groups);
            shareState.setImGroupList(_this.groupsMess);
          }
        });
    },
    addNewClass() {
      // 新建班级弹窗
      this.addClassModel = true;
    },
    cancelNewClass() {
      this.addClassModel = false;
    },
    addNewClassFun() {
      // 新建班级确定
      // if(!this.newClassName || this.newClassName ==''){
      //   this.$message.warning('请您输入班级名称')
      //   return false
      // }
      if (this.newClassName.length > 16) {
        this.$message.warning('请您输入班级名在16个汉字以内');
        return;
      }
      const param = {
        userId: this.$store.state.userInfo.id,
        className: this.newClassName,
        classInfo: '',
      };
      const _this = this;
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/class/common/createClass',
          body: param,
        })
        .loading(
          () => (_this.loading = true),
          () => (_this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.$message.success('新建班级成功');
            _this.addClassModel = false;
            _this.getClassNum();
          }
        });
    },
    lookApply (item) {
      this.applyVisible = true
      this.getStudentsApply(item.id);
    },
    handleCancel () {
      // 加入班级弹窗
      this.applyVisible = false
    },
    sureFun (item) {
      // 同意加入班级
      this.applyParam = {
        studentId: item.userId,
        userId: this.$store.state.userInfo.id,
        classId: item.classId,
        isPermit: '1'
      }
      this.apply(item.classId)
    },
    refuseFun (item) {
      // 拒绝加入班级
      this.applyParam = {
        studentId: item.userId,
        userId: this.$store.state.userInfo.id,
        classId: item.classId,
        isPermit: '2'
      }
      this.apply(item.classId)
    },
    apply (id) {
      const _this = this
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/class/common/setStudentsApplyClass',
          body: _this.applyParam
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.getStudentsApply(id)
            _this.$message.success(res.resultMessage)
            _this.getClassNum()
            // _this.applyVisible = false
          }
        })
    },
    getStudentsApply (id) {
      // 获取学生加入班级列表
      //  const classMess = this.shareData.imGroupList?.find((g) => g.groupTag === this.groupid)
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/common/getClassJoinApplyList',
        body: { classId: id }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.applyList = res.resultData
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.name === 'AccompanyStudy') {
      next((vm) => {
        vm.startTimer();
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (from.name === 'AccompanyStudy') {
      clearInterval(this.timer);
      this.timer = null;
      next();
    }
  },
};
</script>
<style lang="less" scoped>
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.main {
  width: 1240px;
  margin: 0 auto;
  background: #fff;
  padding: 0px 20px;
  .question {
    height: 120px;
    background: #fff;
    display: flex;
    .queLeft {
      width: 430px;
      height: 120px;
      font-family: PingFangSC-Regular;
      background-color: #f9f5ef;
      background-image: url('../../assets/image/1-01.png');
      background-size: 100% 100%;
      border-radius: 8px;
    }
    .queCenter {
      width: 430px;
      height: 120px;
      margin-left: 40px;
      background-image: url('../../assets/image/1-02.png');
      background-size: 100% 100%;
      border-radius: 8px;
    }
    .queRight {
      width: 260px;
      height: 120px;
      margin-left: 40px;
      background-image: url('../../assets/image/1-03.png');
      background-size: 100% 100%;
      border-radius: 8px;
      .classification {
        height: 120px;
        line-height: 120px;
        text-align: center;
        .text {
          font-size: 24px;
          color: #000000;
        }
        img {
          width: 15px;
          height: 16px;
          margin-left: 10px;
          margin-top: -8px;
        }
      }
    }
    .open_issus {
      text-align: right;
      padding: 5px 20px 0px 0px;
      height: 44px;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 44px;
      letter-spacing: 0px;
      color: #000000;
    }
    .num {
      text-align: right;
      padding: 5px 20px 0px 0px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 28px;
      letter-spacing: 0px;
      color: @primary-color;
      .more {
        width: 15px;
        height: 16px;
        margin-left: 5px;
        margin-top: -3px;
      }
    }
  }
  .taskManger {
    width: 100%;
    height: 250px;
    margin-top: 30px;
    // background-color: #d09e71;
    background-image: url('../../assets/image/a_bgc.png');
    background-size: 100% 100%;
    border-radius: 12px;
    padding: 30px 50px;
    display: flex;
    .taskLeft {
      flex: 1;
      text-align: right;
      .taskLeftText {
        background-image: url('../../assets/image/a_text.png');
        background-size: 100% 100%;
        width: 40px;
        height: 190px;
        margin-left: 45px;
      }
    }
    .taskRight {
      flex: 5;
      background-color: rgba(255, 255, 255, 0.15);
      padding: 30px 80px;
      border-radius: 8px;
      .col {
        text-align: center;
        cursor: pointer;
        img {
          width: 100px;
          height: 100px;
        }
        .text {
          margin-top: 10px;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.6);
          font-family: PingFangSC-Semibold;
        }
      }
    }
  }
  .className {
    height: 50px;
    width: 100%;
    display: flex;
    margin-top: 30px;
    .nameLeft {
      flex: 1;
      text-align: left;
      .border {
        display: inline-block;
        width: 6px;
        height: 15px;
        background-color: @primary-color;
        border-radius: 4px;
      }
      .borderName {
        color: #000000;
        font-size: 18px;
        margin-left: 20px;
      }
    }
    .nameRight {
      flex: 1;
      text-align: right;
      .classBtn {
        height: 40px;
        background-color: @primary-color;
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .mesList {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    ul {
      background: #fff;
      li {
        height: 218px;
        background: #f6f6f6;
        margin: 10px 0px;
        border-radius: 12px;
        display: flex;
        .mesLeft {
          flex: 4;
          height: 200px;
          padding: 10px 10px 10px 20px;
          .mesTitle {
            font-family: PingFangSC-Semibold;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 94px;
            height: 94px;
            letter-spacing: 0px;
            color: #000000;
            cursor: pointer;
            display: flex;
            .class-name {
              display: inline-block;
              max-width: 800px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .mesImg {
              width: 20px;
              height: 20px;
              margin-right: 6px;
              margin-top: 36px;
              margin-left: 15px;
            }
          }
          .mesCont {
            background: #fff;
            min-height: 94px;
            border-radius: 12px;
            padding: 20px;
            .mesImg {
              width: 16px;
              height: 16px;
              margin-right: 3px;
              margin-top: -4px;
            }
            .mesContNotice {
              margin-left: 10px;
            }
          }
        }
        .mesRight {
          flex: 1;
          display: flex;
          padding: 10px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .mangerRight {
            width: 170px;
            height: 150px;
            background: #fff;
            border-radius: 12px;
            text-align: center;
            img {
              width: 80px;
              height: 70px;
              margin-top: 25px;
            }
            .imgText {
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #a3af90;
              height: 50px;
              line-height: 50px;
            }
          }
        }
      }
    }
  }
}
.classNumber {
  min-height: 260px;
  .classTop {
    .classSelect {
      height: 40px;
      line-height: 40px;
    }
  }
  .classBot {
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    .cancelButton {
      width: 180px;
    }
    .classSureButton {
      width: 180px;
      background: @primary-color;
      color: #fff;
      margin-left: 10px;
    }
  }
  /deep/.ant-modal-close-x {
    display: none;
  }
}
.classGroup {
  margin-bottom: 5px;
}

.tooltips {
  color: #db5647;
  display: inline-block;
  margin-left: 25px;
  cursor: pointer;

  /deep/ .anticon {
    vertical-align: -0.15em;
  }

  .joinClass {
    font-size: 16px;
    margin-left:5px;
    margin-bottom:5px;
  }
}
.applyLi {
  height: 120px;

  .applyName {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: #040506;

    .userImg {
      width: 44px;
      height: 44px;
      border-radius: 50%;
    }
    .userName {
      margin-left: 10px;
      color: @primary-color;
    }

    .name {
      color: #040506;
      margin-left: 10px;
    }

    .className {
      color: #db5647;
      margin-left: 10px;
    }
  }

  .applyFun {
    float: right;

    .sure {
    }

    .refuse {
      margin-left: 20px;
    }
  }
}
</style>
